export enum AuthenticationStep {
  Loading,
  Setup,
  Enroll,
  StepUp,
  Notification,
  Error
}
